// extracted by mini-css-extract-plugin
export var fadeIn = "_g2-1";
export var modalContent = "_g2-3";
export var overlay = "_g2-0";
export var popoverContent = "_g2-2";
export var results = "_g2-5";
export var searchInputWrapper = "_g2-4";